module.exports = __webpack_public_path__ + "img/sample-data-stamp-white.0e6bdbf7.svg";